<template>
    <div>
        <div class="container wrapper-DetailActs">
        
            <div class= "wrapperdiv">
                <div>
                    <b-breadcrumb :items="itemsBreadCrumb" style="padding: 0; background-color: initial;"></b-breadcrumb>
                </div>
                <div>
                    <router-link :to="{ name: 'listActs'}" class="text_btn2 text_btn-gobackSearch">
                        <button style= "margin: 0;" class="btn_1 btn-gobackSearch"> {{$t('btn_gobackSearch')}}</button>
                    </router-link>
                </div>
            </div>
            <template v-if="loadingResumeAct">
                <div style="color:#1937a0"><b-spinner  small></b-spinner> Carregando ...</div>
            </template>
            <template v-else>
                <div style="display: grid;  grid-template-columns: 1fr auto; margin-top: 15px; align-items: center;">
                    <div class="textResume" style="display:inline; position:relative">
                        {{this.currentVersion.title}}
                        <div class= "btnFullText" v-if="positionElementFullText>800" @click="scrollIntoActFullText">
                            {{$t('actFullText')}}
                        </div>
                    </div>
                    
                    <div class="grid-dots">
                        <div class="elem-dots">
                            <span class="dot" v-bind:class="textAdded ? 'dotAdded' : 'dotDisable'"></span>
                            <span v-bind:class="this.textAdded ? 'textDot' :'textDotDisable' ">Incluiu</span>                                
                        </div>
                        <div class="elem-dots">
                            <span class="dot" v-bind:class="textChanged ? 'dotChanged' : 'dotDisable'"></span>
                            <span v-bind:class="this.textChanged ? 'textDot' :'textDotDisable' ">Alterou</span>                                       
                        </div>      
                        <div class="elem-dots">
                            <span class="dot" v-bind:class="textRemoved ? 'dotRemoved' : 'dotDisable'"></span>
                            <span v-bind:class="this.textRemoved ? 'textDot' :'textDotDisable' ">Revogou</span>                                 
                        </div>                         
                    </div>                
                </div>
                <template v-if="textAdded || textChanged || textRemoved">
                    <hr>
                    <p style="color:#a2a2a2">
                        {{$t('modificationsResume')}}
                        <b-icon icon="info-circle" v-b-tooltip.hover :title="$t('infoModificationsResume')"></b-icon>
                    </p>
                </template>

                <div v-for="(resumeAct,index) in resumeActs" v-bind:key="index">   
                    <div v-for="(change, index) in resumeAct.changes" v-bind:key="`change-${index}`" class="grid-resume">
                        <div class="icon-arrow">
                            <b-icon stacked icon="arrow-right" scale="0.7"  variant="secondary" ></b-icon>     
                        </div>                           
                        <div>
                            <div class="text-resumo">
                                <span 
                                    @click="showDialogAct(resumeAct.number,resumeAct.type_act,$route.params.actType,resumeActs.dateAct, $route.params.actNumber,change.unity)"
                                    v-bind:class="[change.change_type == 1 ? 'change_highlight' : (change.change_type == 2 ? 'added_highlight' : 'removed_highlight') ]">
                                    {{resumeAct.type_act | capitalize}} Nº. {{resumeAct.number}} - {{change.text}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <template v-if="actVersions.versions">
                    <div v-if="actVersions.versions.length > 1" style="display: grid; grid-template-columns: 50px 270px; justify-content: flex-end; align-items: center;">
                        {{$t('version')}}
                      
                        <md-field>
                            <md-select class="selectAto" v-model="actVersionId" name="versao" @md-selected="onChangeSelect">
                                <md-option v-for="(version,index) in actVersions.versions" :value="actVersions.versions[index].id" :key="actVersions.versions[index].id" :name="actVersions.versions[index].id"> 
                                    <template v-if="actVersions.versions.length-1 ==index">
                                        {{$t('original')}}
                                    </template>
                                    <template v-else>
                                        <template v-if="index == 0">
                                            {{$t('current')}} {{$t('versiongiven')}} {{version.id}}
                                        </template>
                                        <template v-else>
                                            {{$t('versiongiven')}} {{version.id}}
                                        </template>
                                    </template>
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>
                </template>
                <div style="color:#a2a2a2; margin-bottom:10px" ref="actFullTextId">
                    <b-icon icon="info-circle" v-b-tooltip.hover :title="$t('infoActFullText')"></b-icon> {{$t('actFullText')}}: 
                </div>
                
                <div v-if="loadingActText" class="loadingData">
                    <strong>Carregando...</strong>
                    <b-spinner style="color:#1937a0" small></b-spinner>
                </div>
          
                <template v-if="actRevoked || actWithTextAdd || actWithTextChanged || actWithTextRemoved" >
                    <div style="margin-bottom:45px;">
                        <div class="dotAdded" v-if="actWithTextAdd" v-html="$t(actModifiedPronoun) + $t('actWithTextAdd', { acttype: actModifiedType , actNumber: actModifiedNumber, actDate:actModifiedDate})"></div>
                        <div class="dotChanged" v-if="actWithTextChanged" v-html="$t(actModifiedPronoun) + $t('actWithTextChanged', { acttype: actModifiedType , actNumber: actModifiedNumber, actDate:actModifiedDate})"></div>
                        <div class="dotRemoved" v-if="actWithTextRemoved" v-html="$t(actModifiedPronoun) + $t('actWithTextRemoved', { acttype: actModifiedType , actNumber: actModifiedNumber, actDate:actModifiedDate})"></div>
                        <div class="actRevoked2 dotRemoved" v-if="actRevoked" v-html="$t('actRevoked',{ acttype: actModifiedType , actNumber: actModifiedNumber, actDate:actModifiedDate})"></div>
                    </div>
                </template>
               
                <div class="headerAct">
                    <div class="brasao-brasil" alt="Cabeçalho - Brasão do Brasil" title="Cabeçalho - Brasão do Brasil"></div>
                    <p class="titPrincAto">PRESIDÊNCIA DA REPÚBLICA</p>
                    <!-- <p class="titPrincAtoPubData"> Publicado em: {{currentVersion.publication_date | formatDateString}}</p> -->
                </div>
                
                <div class="styleActFullText" v-html= currentVersion.template></div>

                <div class="btnModificationsResume" :class="classBackToTop" @click="backToTop()">
                    <md-icon style="color:#fff">expand_less</md-icon>
                </div>           
            </template>
                     
        </div>

        <md-dialog class="dialogAtoModified" :md-active.sync="showDialog">
            
                <div class="icon-close">
                    <b-icon stacked icon="x" @click="closeDialog()" scale="1.1" class="style-x" v-b-tooltip.hover title="Fechar" ></b-icon>
                </div>
                    
                <div style="display: grid;  grid-template-columns: 1fr auto; margin-top: 15px; padding-left: 15px; padding-top: 12px; padding-right: 55px;">

                    <div class="textResume" >
                        {{actModifiedTitle}}
                    </div>
                    
                    <template v-if="!loadingAct && !noData && !has_revoked">
                        <div class="grid-dots" style="margin-bottom:initial">
                            <div class="elem-dots" v-b-tooltip.hover title="Incluiu texto em outro decreto">
                                <span class="dot" v-bind:class="textAdded ? 'dotAdded' : 'dotDisable'"></span>
                                <span v-bind:class="this.textAdded ? 'textDot' :'textDotDisable' ">Incluiu</span>                                
                            </div>
                            <div class="elem-dots" v-b-tooltip.hover title="Alterou texto em outro decreto">
                                <span class="dot" v-bind:class="textChanged ? 'dotChanged' : 'dotDisable'"></span>
                                <span v-bind:class="this.textChanged ? 'textDot' :'textDotDisable' ">Alterou</span>                                       
                            </div>      
                            <div class="elem-dots" v-b-tooltip.hover title="Revogou texto em outro decreto">
                                <span class="dot" v-bind:class="textRemoved ? 'dotRemoved' : 'dotDisable'"></span>
                                <span v-bind:class="this.textRemoved ? 'textDot' :'textDotDisable' ">Revogou</span>                                 
                            </div>                         
                        </div>
                    </template>
                    <template v-if="has_revoked"><div style="margin-right:10px; color:red; font-weight:600">DECRETO REVOGADO</div></template>
            
                </div>   

                <template v-if="!loadingAct && !noData">
                    <md-divider style="margin-left: 15px; margin-top: 10px; margin-bottom: 10px; margin-right: 25px;"></md-divider>
                
                    <div class="styleActModifiedFullText styleActFullText"  v-html="templateHtmlDialog"></div>  
                </template>

                <div v-if="loadingAct" class="loadingData">
                    <strong>Carregando...</strong>
                    <b-spinner style="color:#1937a0" small></b-spinner>
                </div>

                <div v-if="noData" class="noData">
                    {{msgInfo}}
                </div>

                
    
        </md-dialog> 

        

    </div>    
</template>

<script>
    import {APIService} from '@/apiService';
    const apiService = new APIService();
    import i18n from '@/i18n.js'
    import moment from 'moment'

    import {parse, format, isValid} from 'date-fns'


    export default {    
       
        data() {
            return{

                showDialog: false,
                idElemSelect : '',
                
                loadingResumeAct: false,
                resumeActs:[{
                    "type_act"  : Number,
                    "number"    : Number,
                    "changes"   :[{
                                    "change_type": Number,
                                    "unity": String,
                                    "text": String,
                        }
                    ]
                }],
                currentVersion:{
                    "template"  : String,
                    "unities":[{
                        "unitiy" : String,
                        "text"   : String
                    }]
                },
                templateHTML : String,

                templateHtmlDialog: String,
                unitiesDialog: [],

                itemsBreadCrumb: [],

                //variaveis para a modal com as modificacoes 
                textAdded :false,
                textRemoved :false,
                textChanged :false,
                has_revoked : false,

                actModifiedTitle :'',

                loadingAct : false,

                noData : false,
                msgInfo : '',
                
                positionElementFullText:0,
                classBackToTop : '',

                
                //variaveis para a tela de texto na integra

                actRevoked:false,
                actWithTextAdd:false,
                actWithTextChanged:false,
                actWithTextRemoved:false,
                
                actModifiedPronoun:'',
                actModifiedType    : '',
                actModifiedNumber  : '',
                actModifiedDate    : '',

                actVersions : [],
                

                loadingActText : false,

                actVersionId:'',
            }
        },

        computed: {

            searchedWords: {
                get () {
                    return this.$store.state.searchedWords
                },
                set (value) {
                    this.$store.commit('setSearchedWords', value)
                }
            },

    
        },

        methods: {
            onChangeSelect(){
                var filterParams =  {};
                filterParams["type"]    = this.$route.params.actType;
                filterParams["number"]  = this.$route.params.actNumber;
                filterParams["version"]  = this.actVersionId;
                this.getActText(filterParams);
                this.mountInfoVersions();
            },
            
            
            closeDialog: function(){
                this.showDialog = false;
            },

            mountCurrentVersionHTML(){
                for (var i = 0; i < this.currentVersion.unities.length; i++) {
                    this.currentVersion.template = this.currentVersion.template.replace("{#"+this.currentVersion.unities[i].unity+"#}",this.currentVersion.unities[i].text);
                }
                this.currentVersion.template = this.currentVersion.template.replaceAll(/({#.*?#})/g,"");
              
                this.currentVersion.template =  this.templatesString(this.currentVersion.template)  
            },

            showDialogAct(number,type_act,compare_type,dateAct,compare_version,idElemSelect){
                
                this.showDialog = true;
                this.actModifiedTitle = "Carregando...";
                this.templateHtmlDialog = "";
                this.msgInfo = "";
                this.noData = false;
                this.has_revoked = false;

                this.idElemSelect = idElemSelect;

                var filterParams =  {};
                filterParams["number"]             = number;
                filterParams["type"]               = type_act;
                filterParams["compare_type"]       = compare_type;
                filterParams["compare_version"]    = compare_version;

                this.loadingAct = true;

                this.templateHtmlDialog = "";
                
                apiService.getDetailActChanges(apiService.objectToQuerystring(filterParams)).then((data) => {
                    try {
                        if(!this.isEmpty(data)) {
                            this.loadingAct = false;
                            this.actModifiedTitle = data.title;
                           
                            this.templateHtmlDialog = this.templateHtmlDialog + 
                            '<div class="headerAct">'+
                                '<div class="brasao-brasil" alt="Cabeçalho - Brasão do Brasil" title="Cabeçalho - Brasão do Brasil"></div>'+
                                '<p class="titPrincAto">PRESIDÊNCIA DA REPÚBLICA</p>'+
                                // '<p class="titPrincAtoPubData"> Publicado em: ' + this.$options.filters.formatDateString(data.publication_date) + '</p>'+
                            '</div>'

                           

                            this.templateHtmlDialog = this.templateHtmlDialog + data.template; 
                            
                            this.templateHtmlDialog = this.templateHtmlDialog.replace(/Texto para impressão/g,"")
                            this.templateHtmlDialog = this.templateHtmlDialog.replace(/TEXTO PARA IMPRESSÃO/g,"") 
                            this.templateHtmlDialog = this.templateHtmlDialog.replace(/Texto compilado/g,"") 
                                                    

                            this.unitiesDialog = data.unities;
                    
                            for (var i = 0; i < this.unitiesDialog.length; i++) {

                               
                                
                                if(this.unitiesDialog[i].change_type){
                                    
                                   var  classCssCompareText =''
                                    switch (this.unitiesDialog[i].change_type) {
                                        case 2: 
                                            classCssCompareText = 'textAdded';
                                            this.textAdded = true;
                                            break;
                                        case 3: 
                                            classCssCompareText = 'textRemoved';
                                            this.textRemoved = true;
                                            break;                        
                                        case 1: 
                                            classCssCompareText = 'textChanged';
                                            this.textChanged = true;
                                    }

                                   
                                
                                    var classCssTypeText = "";
                                    if(this.unitiesDialog[i].unity.includes('inc')){
                                        classCssTypeText = "inc " ;
                                    }else if(this.unitiesDialog[i].unity.includes('par')){
                                        classCssTypeText = "par "; 
                                    }else if(this.unitiesDialog[i].unity.includes('art')){
                                        classCssTypeText = "art ";
                                    }
                                
                                    if(this.unitiesDialog[i].change_type == 1){
                                        var stringPreposition = "";
                                        if(type_act == "decreto")
                                            stringPreposition = "pelo ";
                                        else 
                                            stringPreposition = "pela ";

                                    
                                        var stringHTML = "<div id='"+ this.unitiesDialog[i].unity+"' class='"+ classCssTypeText +  classCssCompareText +"'>"+
                                                            "<div><span>Texto Antigo:</span><br><p>"+ this.unitiesDialog[i].text + "</p></div>"+
                                                            "<div>"+ 
                                                                "<span>Novo Texto " + "(Redação dada " + 
                                                                    stringPreposition + 
                                                                    this.currentVersion.title.split("-")[0] + "de" + 
                                                                    this.currentVersion.title.split("de")[1] +" de " + this.currentVersion.title.split("de")[2]  + "):</span><br>" 
                                                                + "<p>" + this.unitiesDialog[i].new_text + "</p>" +  
                                                            "</div>"+
                                                        "</div>";
                                        this.templateHtmlDialog = this.templateHtmlDialog.replace("{#"+this.unitiesDialog[i].unity+"#}",stringHTML);
                                    }else{
                                
                                        var stringHTML = "<div id='"+ this.unitiesDialog[i].unity+"' class='"+ classCssTypeText + classCssCompareText +"'>"+
                                                            "<p>"+ this.unitiesDialog[i].text + "</p>"+
                                                        "</div>";
                                        this.templateHtmlDialog = this.templateHtmlDialog.replace("{#"+this.unitiesDialog[i].unity+"#}",stringHTML);
                                    }
                                }
                                else 
                                    this.templateHtmlDialog = this.templateHtmlDialog.replace("{#"+this.unitiesDialog[i].unity+"#}",this.unitiesDialog[i].text);
                                
                               
                            }
                            this.templateHtmlDialog = this.templateHtmlDialog.replaceAll(/({#.*?#})/g,"");                           
                            
                            this.templateHtmlDialog = this.templatesString(this.templateHtmlDialog);

                            if(data.has_revoked){   
                                this.templateHtmlDialog = this.templateHtmlDialog.replaceAll('<p class="','<p class="textRemoved ');
                            }
                           
                            if(!data.has_revoked){
                                this.$nextTick().then(function () {
                                    var element = document.getElementById(idElemSelect);
                                    element.scrollIntoView({block: "start", behavior: "smooth"});
                                })
                            }
                            
        
                            
                        }else{
                            this.loadingAct = false;

                            this.noData = true;
                            this.msgInfo = i18n.t('noData');
                            this.actModifiedTitle ="";
                          
                        }                        
                    }
                    catch (e) {
                        console.log(e)
                        this.noData = true;
                        this.msgInfo = i18n.t('noData');
                        this.actModifiedTitle ="";
                    }
                    
                })
                .catch(error => {
                    this.loadingAct = false;
                    this.noData = true;
                    this.msgInfo = i18n.t('noData');
                    this.actModifiedTitle ="";
                })         
            },

            templatesString(string){
                
                // string = string.replace(/O PRESIDENTE DA REPÚBLICA/g,"O <b>PRESIDENTE DA REPÚBLICA</b>"); 
                // string = string.replace(/caput/g,"<b>caput</b>");
                
                // string = string.replace('<p class="info-text">Brasília','<p class="info-text data-act">Brasília');
                // string = string.replace(/Texto para impressão/g,"")
                // string = string.replace(/TEXTO PARA IMPRESSÃO/g,"")
                // string = string.replace(/Texto compilado/g,"") 
              
                // string = this.templateStringSignature(string);
                

                // //logica para incisos sem paragrafo
                // var array = string.split('<p')

                // array.forEach(function (item, index) { 
                //     array[index]= array[index].replace("class","<p class"); 
                // }); 

                // array.forEach(function (item, index) {
                //     if (!array[index + 1]) return;
                
                //     if (array[index].includes("art") && array[index + 1].includes('class="inc"')){
                //         array[index + 1] = array[index + 1].replace('class="inc"','class="inc-no-par"')
                //     } 
                //     if (array[index].includes("inc-no-par") && array[index + 1].includes('class="inc"')){
                //         array[index + 1] = array[index + 1].replace('class="inc"','class="inc-no-par"')
                //     } 
                //     if (array[index].includes("inc-no-par") && array[index + 1].includes('class="info-text"')){
                //         array[index + 1] = array[index + 1].replace('class="info-text"','class="info-text-no-par"')
                //     }
                //     if (array[index].includes("info-text-no-par") && array[index + 1].includes('class="info-text"')){
                //         array[index + 1] = array[index + 1].replace('class="info-text"','class="info-text-no-par"')
                //     } 
                //     if (array[index].includes("info-text-no-par") && array[index + 1].includes('class="inc"')){
                //         array[index + 1] = array[index + 1].replace('class="inc"','class="inc-no-par"')
                //     } 
                // }); 
            
                //string = array.filter(function (el) {return el != "";}).join(' ');
                                           
                return string;   
            },
            
            templateStringSignature(string){

                if (string.includes('Brasília')){ 
                    var signatureTextOriginal = string.slice(string.indexOf("Brasília"))                   
                    var signatureText = signatureTextOriginal.slice(0, signatureTextOriginal.indexOf(";")+1) + "<br>" + signatureTextOriginal.slice(signatureTextOriginal.indexOf(";")+1)
                   
                    signatureText = signatureText.replace(/BOLSONARO/g,"BOLSONARO<br>");
                    signatureText = signatureText.replace(/Paulo Guedes/g,"Paulo Guedes<br>");
                    signatureText = signatureText.replace(/Onyx Lorenzoni/g,"Onyx Lorenzoni<br>");
                    signatureText = signatureText.replace(/Augusto Heleno Ribeiro/g,"Augusto Heleno Ribeiro<br>");
                    signatureText = signatureText.replace(/Wagner de Campos Rosário/g,"Wagner de Campos Rosário<br>");
                    signatureText = signatureText.replace(/Carlos Alberto dos Santos Cruz/g,"Carlos Alberto dos Santos Cruz<br>");         
                    
                    
                    signatureText = signatureText.replace(/Silva/g,"Silva<br>");
                    signatureText = signatureText.replace(/SILVA/g,"SILVA<br>");
                    signatureText = signatureText.replace(/Dilma Rousseff/g,"Dilma Rousseff<br>");
                    signatureText = signatureText.replace(/DILMA ROUSSEFF/g,"DILMA ROUSSEFF<br>");
                    signatureText = signatureText.replace(/Guido Mantega/g,"Guido Mantega<br>");
                    signatureText = signatureText.replace(/Márcio Thomaz Bastos/g,"Márcio Thomaz Bastos<br>");
                    signatureText = signatureText.replace(/Fernando Haddad/g,"Fernando Haddad<br>");
                    signatureText = signatureText.replace(/FERNANDO HENRIQUE CARDOSO/g,"FERNANDO HENRIQUE CARDOSO<br>");
                    signatureText = signatureText.replace(/Fernando Henrique Cardoso/g,"Fernando Henrique Cardoso<br>");
                    
                    signatureText = signatureText.replace(/Este texto não substitui/g,"<br>Este texto não substitui");
                    signatureText = signatureText.replace('*',"");
                    signatureText = signatureText.replace(/- Edição extra/g,"<br>-<br>Edição extra");

                    string = string.replace(signatureTextOriginal, signatureText)
                }
                        
                return string;
            },
            
            isEmpty(obj) {
                
                for(var key in obj) {
                    if(obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
            
            scrollIntoActFullText(){
                window.scrollTo({
                    top: this.positionElementFullText - 15,
                    behavior: "smooth"
                });
            },
            
            handleScroll (event) {
                if(window.scrollY > this.positionElementFullText  - 20){
                    this.classBackToTop = 'showBackToTop';
                }else{
                     this.classBackToTop = 'hideBackToTop';
                }
            },
            
            backToTop: function() {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            },

            formatDateString: function(value){
                moment.locale('pt-br');
                return moment(String(value)).format('DD [de] MMMM [de] YYYY');
            },
            
            async doBeforeMount(){
                this.loadingResumeAct = true;
        
                this.itemsBreadCrumb = [];
                if(this.searchedWords)
                    this.itemsBreadCrumb.push({ text: 'Pesquisa: ' + this.searchedWords, to: { name: 'listActs' }, append: true})
                else
                    this.itemsBreadCrumb.push({ text: 'Pesquisa', to: { name: 'listActs' }, append: true})
                
                this.itemsBreadCrumb.push({ text: 'Resumo do Ato', active: true});

                this.currentVersion.template = "";
                this.resumeActs = [];
                
                var filterParams =  {};
                filterParams["type"]    = this.$route.params.actType;
                filterParams["number"]  = this.$route.params.actNumber;
                
                
                apiService.getResumeAct(apiService.objectToQuerystring(filterParams)).then((data) => {    
                    if(data){
                        this.resumeActs = data;
                        
                        for (let index = 0; index < this.resumeActs.length; index++) {
                            var changes = this.resumeActs[index].changes;
                            for (let index2 = 0; index2 < changes.length; index2++) {
                                var changeType = changes[index2].change_type;                            
                                if(changeType == 1)
                                    this.textChanged= true;
                                else if(changeType == 2)
                                    this.textAdded = true;
                                else if(changeType == 3)
                                    this.textRemoved = true;
                            }
                        }
                        this.loadingResumeAct = false;
                    }

                });

                this.getActText(filterParams);
                
                this.getActVersions(filterParams);
                
                
            },
            
            getActVersions(filterParams){
                apiService.getActVersions(apiService.objectToQuerystring(filterParams)).then((data) => {   
                    this.actVersions = data;
                    this.actVersionId = this.$route.params.actType === "decreto" && this.actVersions.versions[0].id;
                    this.mountInfoVersions();
                })
            },

            getActText(filterParams){
                this.loadingActText = true;
                apiService.getActText(apiService.objectToQuerystring(filterParams)).then((data) => {   
                    
                    if(data){
                        this.currentVersion = data;
                        if (this.$route.params.actType === "decreto") this.mountCurrentVersionHTML();
                        this.loadingActText = false;
                    }
                });
            },

            mountInfoVersions(){ 
                if(this.actVersions){
                    if(this.actVersions.has_revoked){   
                        var element = document.getElementsByClassName('styleActFullText');
                        element[0].classList.add('actRevoked');
                        this.actRevoked = true;
                    }else{
                        
                        for(var i in this.actVersions.versions){
                            
                            if(this.actVersions.versions[i].id == this.actVersionId){
                                //reinicia variaveis
                                this.actRevoked = false;
                                this.actWithTextAdd = false;
                                this.actWithTextChanged = false;
                                this.actWithTextRemoved = false;

                                var current = this.actVersions.versions[i];
                                if(current.changes.length>0){
                                    current.changes.forEach(element => {
                                        switch (element) {
                                            case 1: 
                                                this.actWithTextChanged = true;
                                                break;                          
                                            case 2: 
                                                this.actWithTextAdd = true;
                                                break;                          
                                            case 3: 
                                                this.actWithTextRemoved = true;
                                                break;      
                                        }               
                                        
                                    });
                                    if(current.act_type == 'decreto')
                                        this.actModifiedPronoun = 'este'
                                    else
                                        this.actModifiedPronoun = 'esta'
                
                                    this.actModifiedType    = current.act_type.charAt(0).toUpperCase() + current.act_type.slice(1) ;
                                    this.actModifiedNumber  = current.id;
                                    this.actModifiedDate    = this.formatDateString(current.publish_date);
                                }
                            }
                        }
                    }
                }
            }
             
             
        },

        
        beforeMount(){
            this.doBeforeMount()   
        },  

        // updated(){
        //     this.positionElementFullText = this.$refs.actFullTextId.offsetTop;
        // },

        mounted: function() {
            this.$nextTick(function() {
                //this.initToTopButton();
            });
        },

        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll);
        },

        

        filters: {
            capitalize: function (value) {
                if (!value) return ''
                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            },

            formatDateString: function(value){
                moment.locale('pt-br');
                return moment(String(value)).format('DD [de] MMMM [de] YYYY');
            }

        },
        watch:{
            $route(to,from){
                this.doBeforeMount();
            },

            // actVersionId(){
            //     var filterParams =  {};
            //     filterParams["type"]    = this.$route.params.actType;
            //     filterParams["number"]  = this.$route.params.actNumber;
            //     filterParams["version"]  = this.actVersionId;
            //     this.getActText(filterParams);
            //     this.mountInfoVersions();
            // }
        }
    
    }
</script>

<style scoped lang="scss">

    table, th, td, tr {
        border: 1px solid black;
    }

    .wrapper-DetailActs{
        
        padding-bottom: 260px;
        margin-top: 15px;
        width: 80%;      

        .md-card-content > div:first-child {
            margin-bottom: 15px;
        }
        
        .grid-resume{
            display: grid;
            grid-template-columns: 46px 1fr;
            align-items: center;
        }


        .wrapperdiv{
            display: grid;
            grid-template-columns: 1fr 1fr;
            align-items: baseline;
        }
        .wrapperdiv > div:last-child {
            text-align:right;
        }

        .md-raised{
            margin: 0 !important;
        }

        .text-resumo {
            padding: 5px;
        }

        .text-status {
            width:20%;
            position: relative;

            span{
                margin: 0;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-right: -50%;
                transform: translate(-50%, -50%);
                font-style: italic;
                text-decoration: underline;
            }
        }

        .cabecalho{
            text-align:center;
        }
        .cabecalho-titulo {
            text-align:center;
            color:#000;
            font-family: "Times New Roman",Times,serif;
            font-size: 2em;
            text-transform: uppercase;
            margin: 12px 10px 10px;
        }   

        .btn-gobackSearch{
            width: 160px;
            height: 35px;
            color:#fff;
            &:hover{
                color:#fff;
            }
        }
        .text_btn-gobackSearch{
            font-weight: initial;
            font-size: 15px;
           
        }

       
    }

    .grid-dots{
        display: grid;
        justify-content: right;
        grid-template-columns: 85px 85px 85px;
    }

    ::v-deep .brasao-brasil {
        background-image: url('../assets/brasao.png');
        height: 100px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100px 100px;
        margin-bottom: 15px;
    }

   
    ::v-deep .styleActFullText{
        word-wrap: break-word;
        font-family: 'rawline',sans-serif;
        text-align: justify;
        line-height: 1.5;
        text-indent: 5em;
        font-size: 1.125rem;
        font-weight: 500;

        .mention{
            text-indent: 10rem;
            padding: 10px;
            background-color: #f3f3f385;
            margin: 0;
            font-style: italic;
        }
    }

    ::v-deep .text-center{
        text-align: center;
    }
    
   

    .dialogAtoModified {
       ::v-deep .md-dialog-container{
            max-width: initial;
            max-height: initial;
            width: 98%;
            height: 98%;
            background-color: #fff !important;
        }
        .wrapper-dialog{
            background-color: #fff !important;
        }
    }

    .styleActModifiedFullText{
        padding: 0 15px 0px 10px;
        height: 100%;
        overflow-y: scroll;
        margin-right: 5px;
        margin-bottom: 10px;
        margin-left: 5px;
         line-height: 1.5;

        ::v-deep .textChanged{
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 5px;
        }

        ::v-deep .textChanged > div{
            padding-left: 6px;
            padding-right: 6px;
            margin:5px 0px 5px 0px;
            background-color: #ffdc5f;
            text-indent: initial;
        }

        ::v-deep .textAdded{
            background-color: #78f4a2;
        }

        ::v-deep .textRemoved{
            background-color: #f57867;
            margin-top: 15px;
        }

        &::-webkit-scrollbar-track{
            background-color: #c9c9c9;  
            border-radius: 20px;       
        }

        &::-webkit-scrollbar{
	        width: 12px;
	        background-color: #c9c9c9 ;
            border-radius: 20px;
            margin-bottom: 8px;           
            margin-top: 8px;  
        }

        &::-webkit-scrollbar-thumb{
            border-radius: 20px;
            background-color: #646464;
            margin-bottom: 8px;           
            margin-top: 8px;  
        }
       
    }
       

    .textResume{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        color: #000000;
    }

    
    ::v-deep .alignCenter{
        text-align: center;
    }


    ::v-deep .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
    }

    ::v-deep.tooltip .tooltiptext {
        visibility: hidden;
        width: 120px;
        background-color: #555;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        margin-left: -60px;
        opacity: 0;
        transition: opacity 0.3s;
    }

    ::v-deep.tooltip .tooltiptext::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #555 transparent transparent transparent;
    }

    ::v-deep.tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }

    .btnFullText{
        display: inline-flex;
        font-size: 13px;
        background: #fff;
        color: #a7a7a7;
        position: absolute;
        right: 10px;
        top: 1px;
        border-radius: 25px;
        padding-left: 3px;
        padding-right: 3px;
        height: 25px;
        line-height: 23px;
        font-weight: 100;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
        cursor:pointer;

        &:hover{
            color: #777777;
            box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
        }

    }

    .btnModificationsResume{
        background-color: #092484;
        border-radius: 15px;
        padding: 15px;
        position: fixed;
        box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
        display: block;
        right: 15px;
        bottom: 15px;
        border: none;
        opacity: 0;
        z-index: 9999;
        &:hover {
            cursor:pointer;
            opacity: 1;
            background-color: #1c2b63;
            
        }
    }

    .showBackToTop{
        opacity: 1;
    }

    .hideBackToTop{
        opacity: 0;
    }

    .dialogAtoModified{
        z-index: 99999999;
    }

    ::v-deep .actRevoked {
       background-color: #f57867;
       padding: 8px;
       
    }

    .actRevoked2{
        color: #f57867;
        padding: 5px;
        padding-left: 0;
        font-weight: 600;
    }

    // .actWithTextAdd {
    //     color: #78f4a2;
    //     text-shadow: 0px 1px 3px #000000;
    // }

    // .actWithTextChanged{
    //     color: #ffdc5f;
    //     text-shadow: 0px 1px 3px #000000;
    // }

    // .actWithTextRemoved{
    //     color: #f57867;
    //     text-shadow: 0px 1px 3px #000000;
    // }



    
</style>
